export default __webpack_public_path__ + "static/stamps-corner-3d69f93e88244c5c5a9fbedff294b7d1.svg";